export const GET_ALL_RECENT_USER_POST_REQUEST = "GET_ALL_RECENT_USER_POST_REQUEST"
export const GET_ALL_RECENT_USER_POST_SUCCESS = "GET_ALL_RECENT_USER_POST_SUCCESS"
export const GET_ALL_RECENT_USER_POST_FAILURE = "GET_ALL_RECENT_USER_POST_FAILURE"